// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1DFOc","loaderOuter":"PageOverlayLoader_loaderOuter__2uJFR"};